var _path, _path2, _path3, _g, _line, _line2, _path4, _line3, _path5, _path6, _g2, _g3, _path7, _path8, _g4, _path9, _g5, _line4, _line5, _circle, _circle2, _g6, _g7, _path10, _path11, _path12, _line6, _path13, _path14, _path15, _g8, _g9, _g10, _rect, _path16, _path17, _path18, _path19, _g11, _g12, _g13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 660 585",
    enableBackground: "new 0 0 660 585",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "whole_click"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4F6",
    d: "M320.1,293.5c-0.9-0.1-1.8-0.2-2.7-0.2h-15.6c-5.5,0-10.6,1.8-14.8,4.9h-39.3v227.6h47.6V358.8 c2.1,0.6,4.2,0.9,6.5,0.9h2.6v161.5h66.1V293.5H320.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E4E5",
    d: "M305.2,512.6V360.3l14.2-1.6C319.4,358.7,311.9,393.6,305.2,512.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E4E5",
    d: "M296.3,512.1V359.8l-14.2-1.6C282.1,358.2,289.7,393.2,296.3,512.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "person_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M381.3,339.3c0,0-3.6,3.6-12.9,5.6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.1,
    y: 507.7,
    fill: "#F2F4F6",
    width: 26.1,
    height: 34.3
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E3E4E5",
    points: "286.1,524.9 260.1,542.1 258.8,523.1  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 286.1,
    y1: 507.7,
    x2: 286.1,
    y2: 542.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c00ff",
    d: "M261,542.1c0,0,13-6.1,24.1,0l1.9,31.9h-29.6L261,542.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c00ff",
    d: "M296.2,574c0-7.5-10.8-15.9-24.1-15.9s-24.1,8.5-24.1,15.9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.8,
    y: 572.6,
    fill: "#4c00ff",
    width: 48.4,
    height: 9.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.3,
    y: 507.7,
    fill: "#F2F4F6",
    width: 26.1,
    height: 34.3
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E3E4E5",
    points: "354.3,524.9 328.3,542.1 327,523.1  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 354.3,
    y1: 507.7,
    x2: 354.3,
    y2: 542.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c00ff",
    d: "M329.2,542.1c0,0,13-6.1,24.1,0l1.9,31.9h-29.6L329.2,542.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c00ff",
    d: "M364.3,574c0-7.5-10.8-15.9-24.1-15.9s-24.1,8.5-24.1,15.9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 572.6,
    fill: "#4c00ff",
    width: 48.4,
    height: 9.9
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    points: "245.7,457.8 245.7,521.2  302.3,521.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    points: "368.3,377.6 368.3,293.1  353.3,293.1 353.3,284.5 254.4,284.5 254.4,293.1 245.7,293.1 245.7,372.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    points: "311.6,521.2 368.3,521.2  368.3,394.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 309.3,
    y: 496.1,
    fill: "#F2F4F6",
    width: 61.4,
    height: 30.8
  })), /*#__PURE__*/React.createElement("rect", {
    x: 277.5,
    y: 119.5,
    fill: "#C9D3DC",
    width: 68.2,
    height: 179.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4DEDE",
    d: "M361.1,144.8c0,0-9.9,47.3-1.1,72.6c8.1,23.2,26.3,82.3,27.6,115.8c0.2,4.4-3.8,7.7-8.1,6.8l-49.2-10.4 c0,0-13.2-51.7-29.7-82.5c-16.5-30.8,1.1-63.8,8.8-79.2s5.5-18.7,5.5-18.7c7.7-44,40.7-25.3,40.7-25.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E4DEDE",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    d: "M357.5,139.3c0,0,70.6,59.5,0.2,135.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E4DEDE",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    d: "M251.5,139.3c0,0-70.6,59.5-0.2,135.3"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E4DEDE",
    d: "M278.3,98.7c0,0-29.9-1.2-36.8,16.1c-6.9,17.3,9.2,28.8,36.8,33.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M242.4,131c5.2,8.3,18.2,14.1,35.9,17.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M278.3,98.7c0,0-29.9-1.2-36.8,16.1 c-2.5,6.2-2,11.6,0.9,16.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E4DEDE",
    d: "M330.1,98.7c0,0,29.9-1.2,36.8,16.1c4.9,12.3-1.9,21.7-16.3,27.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M357.4,139.1c-6.7,4.1-16,7.1-27.3,9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M330.1,98.7c0,0,29.9-1.2,36.8,16.1 c4.1,10.2,0.1,18.4-9.5,24.3"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4F6",
    d: "M277.3,27.7c0,0-6.4,51.1-6.4,80.8s60.3,45.6,70.7,7.1s-9.3-92.4-9.3-92.4L277.3,27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M336.2,36c-2.2-7.8-4-12.7-4-12.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M343.7,104.3c0.6-5,0.9-10.1,0.8-15.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E4E5",
    d: "M297.7,28.2c0,0-6.6,7.6-11.3,7.6s-5.7,16.1-5.7,16.1l-2.8,34c0,0-2.8,26.4,1.9,27.4 c4.7,0.9,26.4,21.7,22.7,23.6c-3.8,1.9-2.8,1.3-14.2-4.1c-11.3-5.4-17.9-11-17.9-29.9s2.8-78.4,10.4-78.4 C288.2,24.4,297.7,28.2,297.7,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F86ED",
    d: "M316.9,31.6h-31.6c-4.8,0-8.8-3.9-8.8-8.7v-1.7c0-4.8,3.9-8.7,8.8-8.7h31.6c4.8,0,8.8,3.9,8.8,8.7v1.7 C325.6,27.6,321.7,31.6,316.9,31.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F86ED",
    cx: 325.6,
    cy: 16.2,
    r: 15.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBD2D2",
    d: "M305.9,164.9c-1.6,0.9-3.2,1.8-4.9,2.6c-7.9,3.8-15.3,8.4-22.8,12.9c-4.5,2.7-9.1,5.4-13.7,8 c0.5,9.8-0.1,20.1-3.5,27.9c-8.8,20-29.7,65.2-27.5,89.5l57.2,4.3c0,0,14.3-38.8,30.8-63.1c16.5-24.3-2.2-57.7-9.9-69.9 C307.5,170.8,306.2,167.1,305.9,164.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4DEDE",
    d: "M254.4,144.8c0,0,9.9,47.3,1.1,72.6c-8.1,23.2-26.3,82.3-27.6,115.8c-0.2,4.4,3.8,7.7,8.1,6.8l49.2-10.4 c0,0,13.2-51.7,29.7-82.5s-1.1-63.8-8.8-79.2s-5.5-18.7-5.5-18.7c-7.7-44-40.7-25.3-40.7-25.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M361.4,221.3c5,14.9,12.7,39.8,18.5,64.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M361.1,144.8c0,0-9.9,47.3-1.1,72.6 c0.4,1.2,0.9,2.5,1.3,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M258.4,173.5c1.2,14.6,1.3,31.8-2.9,44 c-3.4,9.7-8.5,25.7-13.5,43.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M259.9,123.9c0,0,33-18.7,40.7,25.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E4E5",
    d: "M339.6,122c0,0-9.8-5-18.3,2.5c-8.5,7.6-4.7,13.2-4.7,13.2L339.6,122z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E4DEDE",
    d: "M355.5,123.9c0,0-33-18.7-40.7,25.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M355.5,123.9c0,0-33-18.7-40.7,25.3"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    cx: 311.7,
    cy: 217.3,
    r: 4.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M290.7,556c-3.2,0-3.2-2-6.4-1.9 c-3.2,0-3.2,2-6.4,2.1c-3.2,0-3.2-2-6.4-1.9c-3.2,0-3.2,2-6.4,2.1c-3.2,0-3.2-2-6.5-1.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M360,556c-3.2,0-3.2-2-6.4-1.9 c-3.2,0-3.2,2-6.4,2.1c-3.2,0-3.2-2-6.4-1.9c-3.2,0-3.2,2-6.4,2.1c-3.2,0-3.2-2-6.5-1.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M286.3,549.4c-2.3,0-2.4-2-4.7-1.9 c-2.3,0-2.3,2-4.6,2.1c-2.3,0-2.4-2-4.7-1.9c-2.3,0-2.3,2-4.7,2.1c-2.3,0-2.4-2-4.7-1.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M353.4,549.4c-2.3,0-2.4-2-4.7-1.9 c-2.3,0-2.3,2-4.6,2.1c-2.3,0-2.4-2-4.7-1.9c-2.3,0-2.3,2-4.7,2.1c-2.3,0-2.4-2-4.7-1.9"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M283.1,354.4c0.9,0,0,6,25,5.8 s27.9-9.6,27.9-9.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 243.3,
    y: 496.6,
    fill: "#F2F4F6",
    width: 61.4,
    height: 30.3
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 333.6,
    y1: 448.4,
    x2: 333.6,
    y2: 485.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 333.6,
    y1: 410.6,
    x2: 333.6,
    y2: 429.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "j_face_1_",
    "data-svg-origin": "305.45408630371094 39.5",
    transform: "matrix(1,0,0,1,0.43349288888889115,3.034450222222238)",
    style: {
      transformOrigin: "0px 0px 0px"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M307.6,79.4l-0.1,12.6c0,2.9-2.4,5.3-5.4,5.2h0 c-2.9,0-5.3-2.4-5.2-5.4l0.1-12.6"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4c00ff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 273.2,
    y1: 50.9,
    x2: 335.5,
    y2: 50
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c00ff",
    d: "M286.6,77.8L286.6,77.8c-10.2,0.4-18.8-7.6-19.2-17.8L267,49l37-1.4l0.4,11 C304.8,68.8,296.8,77.4,286.6,77.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c00ff",
    d: "M326,76.3L326,76.3c-10.2,0.4-18.8-7.6-19.2-17.8l-0.4-11l37.1-0.2l0.4,9.8 C344.2,67.3,336.2,75.9,326,76.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M290.2,39.5c-2.1,3.6-3.7,2.7-5.9,6.3 c-2.1,3.6-0.5,4.6-2.6,8.2c-2.1,3.6-3.7,2.7-5.9,6.3c-2.1,3.6-0.5,4.6-2.6,8.2c-2.1,3.6-3.7,2.7-5.9,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M296.7,48.6c-1.8,3-3.4,2-5.3,5 c-1.8,3-0.2,4-2,6.9c-1.8,3-3.4,2-5.3,5c-1.8,3-0.2,4-2,7s-3.4,2-5.3,5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M334.6,41.1c-2.1,3.6-3.7,2.7-5.9,6.3 c-2.1,3.6-0.5,4.6-2.6,8.2c-2.1,3.6-3.7,2.7-5.9,6.3c-2.1,3.6-0.5,4.6-2.6,8.2c-2.1,3.6-3.7,2.7-5.9,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M341.1,50.2c-1.8,3-3.4,2-5.3,5 c-1.8,3-0.2,4-2,6.9c-1.8,3-3.4,2-5.3,5c-1.8,3-0.2,4-2,7c-1.8,3-3.4,2-5.3,5"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4F6",
    d: "M307.3,69.6c0,0-8.2-7.1-11.2,0s10.2,6.1,10.2,6.1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M307.3,69.6c0,0-8.2-7.1-11.2,0 s10.2,6.1,10.2,6.1"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 109.4,
    y: 521.8,
    transform: "matrix(0.5 0.866 -0.866 0.5 522.3323 167.5422)",
    fill: "#F2F4F6",
    width: 13.3,
    height: 28.6
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E3E4E5",
    points: "111.5,529 109.4,548.4 120.7,541.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.1,
    y: 526.9,
    fill: "#F2F4F6",
    width: 13.3,
    height: 28.6
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E3E4E5",
    points: "155.4,541.2 142.1,555.5 142.6,540.2  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 100.4,
    y1: 537.5,
    x2: 125.1,
    y2: 523.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 155.4,
    y1: 526.9,
    x2: 155.4,
    y2: 555.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C9D3DC",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    d: "M149.3,351.2c0,0,0,58.2,0,193.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4C8D6",
    points: "164.6,517.7 134,517.7 134,499 164.6,471.4  "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C9D3DC",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    d: "M189.1,351.2c0,0,59.3,111.4-76.6,186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#B4C8D6",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    d: "M149.3,351.2c0,0,0,3.5,0,23.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#B4C8D6",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    d: "M189.1,351.2c0,0,4.4,7.2,8.2,23.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1B7B7",
    d: "M171.5,41.4c0,0-9.4-33.3-40.9-0.8s7.6,146.2,7.6,146.2l29.6,1L171.5,41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4F6",
    d: "M168.5,62.1h-7.2c-6.2,0-11.2-5-11.2-11.2v-0.5c0-6.2,5-11.2,11.2-11.2h7.2c6.2,0,11.2,5,11.2,11.2v0.5 C179.7,57,174.7,62.1,168.5,62.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M168.5,62.1h-7.2c-6.2,0-11.2-5-11.2-11.2v-0.5 c0-6.2,5-11.2,11.2-11.2h7.2c6.2,0,11.2,5,11.2,11.2v0.5C179.7,57,174.7,62.1,168.5,62.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#D4D8D9",
    cx: 165.4,
    cy: 96,
    rx: 41.1,
    ry: 46.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.5,
    y: 163.7,
    fill: "#F2F4F6",
    width: 13.3,
    height: 28.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E4E5",
    d: "M162.6,162.1c0,0,9.2,12.3,8.2,16.3s1,8.2,1,8.2s6.1-3.1,2-18.4S162.6,162.1,162.6,162.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4F6",
    d: "M177.3,170.5c10.6-11.6,17.5-41.3,20.5-64.6c1.9-14.4-9.4-27-23.9-26.8l-16.4,0.2 c-14,0.2-24.9,12.4-23.3,26.4c2.6,22.7,9.2,53.9,26,66.6C166.7,177.4,172.4,175.9,177.3,170.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M176.7,169.9c6.3-4.8,11.4-15.9,15.3-29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9D3DC",
    d: "M179.1,175.8c-2.6,0.6-4.4,2.9-4.6,5.6c-0.1,2-0.8,4.3-2.8,5.4c-4.1,2-14.3,19.4-8.2,42.9 s-8.2,52.1-15.3,74.6s22.5,62.3,38.8,67.4s43.9-22.5,36.8-53.1s-26.6-40.9-26.6-70.5s17.4-50.1,4.6-64.4 C193.6,174.4,184.5,174.5,179.1,175.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4C8D6",
    d: "M204.5,305.2l10.2-9.7c0,0,4.1,5.6,2,10.7s-7.2,10.2-7.2,10.2L204.5,305.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C9D3DC",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M195.4,190.8 c0,0,57.2,54.2,0,119.5"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C9D3DC",
    points: "196.3,282.7 214.7,316.4 194.2,333.8 163.6,304.2  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 196.3,
    y1: 282.7,
    x2: 214.7,
    y2: 316.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4C8D6",
    d: "M169.7,191.1c4.1,1.9,14.3,17.7,8.2,39.2s8.2,47.6,15.3,68.2c7.2,20.6-22.5,57-38.8,61.7 s-43.9-20.6-36.8-48.6c7.2-28,26.6-37.4,26.6-64.5s-17.4-45.8-4.6-58.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9D3DC",
    d: "M158.9,175.4c1.7,0.4,2.8,2.1,2.5,3.8c-0.4,2.6-0.4,6.2,2.1,7.4c4.1,2,14.3,19.4,8.2,42.9 s8.2,52.1,15.3,74.6s-22.5,62.3-38.8,67.4s-43.9-22.5-36.8-53.1c7.2-30.7,26.6-40.9,26.6-70.5s-17.4-50.1-4.6-64.4 C142.7,173.2,153.6,174.1,158.9,175.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4C8D6",
    d: "M143.1,303.2l-15.3-17.3c0,0,4.1-13.8,7.1-9.2c4.1,6.1,13.8,14.3,13.8,14.3L143.1,303.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C9D3DC",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M143.1,187.7 c0,0-57.2,54.2,0,119.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C9D3DC",
    points: "147.7,287.3 129.4,321 149.8,338.4 180.4,308.8  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 147.7,
    y1: 287.3,
    x2: 129.4,
    y2: 321
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    cx: 166.6,
    cy: 210.2,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    cx: 163.6,
    cy: 243.9,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    cx: 169.7,
    cy: 277.6,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    cx: 178.9,
    cy: 311.3,
    r: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M118.1,289.4c0,0,8.2,15.3,15.3,21.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M209.1,262.8c0,0-0.5,13.8-10,25.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M168.2,516.2c0,0-14.3,13.3-28.6,22.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c00ff",
    d: "M101.8,536.4l-1.1,1.1l4.7,9.8c0,0,2.6-2.6,3.8,0.8s-3.8,15.6,0.3,20.7s17.4,1,17.4,9.2s-21.5,3.1-24.5,1 c-3.1-2,1.1-18.3-3.1-24.5c-2-3.1-8.2-10.2-8.2-13.3S99.2,533.6,101.8,536.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c00ff",
    d: "M92.1,543.3v37.8h2l1-34.7C95.1,546.3,91.8,543.3,92.1,543.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c00ff",
    d: "M142.6,555.5c0,0,6.6-5.1,12.3,0l0.9,26.6h-15.1L142.6,555.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c00ff",
    d: "M160.5,582.1c0-6.2-5.5-13.3-12.3-13.3c-6.8,0-12.3,7.1-12.3,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M154.2,570.7c-1.8-1.2-3.8-1.9-6-1.9 c-3.4,0-6.4,1.8-8.6,4.3"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4F6",
    d: "M374.2,473.9"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "person"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#E3E4E5",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    x1: 562,
    y1: 517.8,
    x2: 467,
    y2: 517.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#E3E4E5",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    x1: 543.4,
    y1: 414.8,
    x2: 477,
    y2: 414.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#E3E4E5",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 478.9,
    y1: 376.7,
    x2: 551.3,
    y2: 373.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#E3E4E5",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    x1: 536,
    y1: 374.4,
    x2: 569,
    y2: 559.6
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#E3E4E5",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    x1: 490.4,
    y1: 374.4,
    x2: 457.4,
    y2: 559.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E4E5",
    d: "M448.8,357.9c0,0-2,21.3-7.6,33.2l-2-3.4l-5.4,17.7c0,0-5.2-2.6-13.5-7c-8.3-4.5,9.1-38.8,9.1-38.8 L448.8,357.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M432,389.9c0,0-5.2,9.5-2.8,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M428.5,389.1c0,0-5.2,9.5-2.8,12.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M425.4,387.6c0,0-5.2,9.5-2.8,12.2"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 420.8,
    y: 532.2,
    transform: "matrix(0.9958 -9.123561e-02 9.123561e-02 0.9958 -47.9346 41.8974)",
    fill: "#F2F4F6",
    width: 26.9,
    height: 26
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#F2F4F6",
    points: "530.8,496.5 506.5,487.2 516.1,462.1 524.4,465.3 540.4,471.4 535.7,483.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E3E4E5",
    points: "525,467 541,475.5 537.5,481.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E3E4E5",
    points: "447.3,540.4 447.8,558.5 440.9,558.4  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 422.1,
    y1: 559.4,
    x2: 419.7,
    y2: 533.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 530.8,
    y1: 496.5,
    x2: 506.5,
    y2: 487.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4F6",
    d: "M452.4,390.5l-33.7-15.6c13.3-28.8,19.1-56.6,16.6-80.4c-1.8-17.6-7.6-27.1-7.6-27.2l0.2,0.2l31-20.5 c1,1.5,9.9,15.5,13.1,40.3C475.9,319.1,469.4,353.8,452.4,390.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E4E5",
    d: "M444,270.3c0,0-3.7,0-1.9,6.5c1.9,6.5,7.4,18.6,7.4,18.6s-6.5,7.4-7.4,21.4s4.6,31.6,4.6,31.6l13.9-51.1 L444,270.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M428.6,349.4c6.1-19.6,8.4-38.2,6.7-54.9 c-0.3-2.4-0.6-4.7-1-6.8"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 438,
    y1: 383.2,
    x2: 418.7,
    y2: 374.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M434.3,287.7c-2.3-13.2-6.6-20.3-6.7-20.3 l0.2,0.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M424.6,377.6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E4DEDE",
    strokeWidth: 50,
    strokeMiterlimit: 10,
    d: "M469.1,369.7c0,0-42.7,78-34.4,177.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4DEDE",
    d: "M445.9,341.9c1.3-5.6-5.6,39,28.8,43.7c32.7,4.4,73.4,5.6,75.2-38.5S445.9,341.9,445.9,341.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E4DEDE",
    strokeWidth: 50,
    strokeMiterlimit: 10,
    d: "M524.8,356.7c0,0-125.4,73.4,0,124.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4F6",
    d: "M439.4,263.8l15.8,32.5c0,0-14.9,7.4-9.3,45.5c0,0,45.5-14.9,103.1,13c0,0,14.9-78.9-48.3-104 S439.4,263.8,439.4,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E4E5",
    d: "M503.5,276.8c0,0,6.5,24.1-0.9,38.1c-7.4,13.9-52.9,25.8-52.9,25.8s52.5-10.4,83.8,7.4 c0,0,18.3-30.4,10.9-46.2C536.9,286.1,503.5,276.8,503.5,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M445.9,341.9c0,0,45.5-14.9,103.1,13"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4F6",
    d: "M508.5,327.2c0,0-21.3,10.6-32.9,21.2c-1.1,1-0.4,2.8,1.1,2.8l3.3,0l-10.4,8.5c-3.5,2.8-3.5,8.1-0.1,11 c2,1.7,4.5,3.7,7.3,6.1c8.7,7.1,38.6-27.5,38.6-27.5L508.5,327.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M480.9,360.1c0,0-8.1,10-12.2,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M483.4,363.5c0,0-8.1,10-12.2,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M486.4,366.3c0,0-8.1,10-12.2,8.6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E4E5",
    d: "M486.1,340.7c0,0-3.9,1.2-3,2.1c0.9,0.9,15.8,20.4,12.5,26.5c0,0,8.8-7,7.9-10.7 C502.6,354.9,486.1,340.7,486.1,340.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4F6",
    d: "M503.4,369.7l-5.3-12.1c-1.3-3-3.2-5.7-5.6-8l-10.6-10.2c18.3-13,27.4-25.8,27.2-38.2 c-0.2-10.5-7-20.4-12.7-26.8c-7.2-8.1-17.2-16.3-17.2-16.4l23-27.8c1.1,0.7,11.1,7.4,21.2,18.6c14.7,16.1,22.6,34,22.9,51.6 C546.7,325.8,532.3,349.1,503.4,369.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M502.1,230.2c0.9,0.6,7.6,5.1,15.5,12.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M546.3,300.4c0.3,18.2-7,35.4-21.9,51.2"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5F86ED",
    d: "M495.4,256.1l-59.1,12.5c-8.5,1.8-16.9-3.7-18.7-12.2v0c-1.8-8.5,3.7-16.9,12.2-18.7l59.1-12.5 c8.5-1.8,16.9,3.7,18.7,12.2v0C509.4,245.9,504,254.3,495.4,256.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4F6",
    d: "M405.6,165l67.1-27.7c0,0,17.3,64.9,14.5,93.1c-2.8,28.1-37.6,22-37.6,22S405.1,213.4,405.6,165z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M480.4,170.8c2,9.8,4,20.7,5.3,31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M472.7,137.3c0,0,2.6,9.6,5.5,23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M487.3,217.8c0.1,1.9,0.1,3.7,0.1,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M486.7,209.6c0.3,2.8,0.5,5.6,0.6,8.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E4E5",
    d: "M472.5,156.4c0,0-24.3,12.8-43.6,16.8c-19.3,4.1-12.4,9.2-10.9,18.4c1.5,9.2,15.4,50.2,32,48.2 s34.7-3.7,36.6,5c2,8.7-42.5,4.7-42.5,4.7s-20-16.1-31.9-46.3c-10-25.4-4.7-42.5-4.7-42.5L472.5,156.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F86ED",
    d: "M435.5,248.2c5.7-1.2,6.5,2.4,12.2,1.2c5.7-1.2,5-4.8,10.7-6c5.7-1.2,6.5,2.4,12.2,1.2 c5.7-1.2,5-4.8,10.7-6c5.7-1.2,6.5,2.4,12.2,1.2l1.9,8.8l-55,11.6L435.5,248.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M435.5,248.2c5.7-1.2,6.5,2.4,12.2,1.2 c5.7-1.2,5-4.8,10.7-6c5.7-1.2,6.5,2.4,12.2,1.2c5.7-1.2,5-4.8,10.7-6c5.7-1.2,6.5,2.4,12.2,1.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B4C8D6",
    d: "M470,137.8L401,150.9v0c-3.3-17.6,8.2-34.5,25.8-37.9l5.3-1C449.7,108.7,466.6,120.2,470,137.8L470,137.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9D3DC",
    d: "M477.3,155.6l-72.2,13.7c-5.7,1.1-11.2-2.7-12.3-8.4l-0.3-1.6c-1.1-5.7,2.7-11.2,8.4-12.3l72.2-13.7 c5.7-1.1,11.2,2.7,12.3,8.4l0.3,1.6C486.7,149,483,154.6,477.3,155.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4c00ff",
    d: "M419.3,558.8c0,0,3.1-3.7,6.9-1.5c3.8,2.2,3.8,2.2,3.8,2.2l16.8-3.7v-2.2c0,0,3.1,0,4.6,3.7 c0,0-0.8,6,1.5,8.2c0,0,1.5,0-0.8,2.2c0,0-33.1,13.7-58.2,13.7h-18.4c-2.1,0-3-2.8-1.2-3.9c6.9-4.6,18.9-11.4,28.9-11.3 c6.9,0.1,16-6,16-6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M424.7,570.4c-1.4-1.1-0.2-2.7-1.6-3.8 c-1.4-1.1-2.6,0.5-4.1-0.7c-1.4-1.1-0.2-2.7-1.6-3.8c-1.4-1.1-2.6,0.5-4.1-0.7c-1.4-1.1-0.2-2.7-1.6-3.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M420.2,571.8c-1.4-1.1-0.2-2.7-1.6-3.8 c-1.4-1.1-2.6,0.5-4.1-0.7c-1.4-1.1-0.2-2.7-1.6-3.8c-1.4-1.1-2.6,0.5-4.1-0.7c-1.4-1.1-0.2-2.7-1.6-3.8"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M464.9,375.8c0,0-47.4,54.8,5.6,101.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M445.9,352.1c0,0,2.3,15.3,9.8,24.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M416.7,575.2c-1.4-1.1-0.2-2.7-1.6-3.8 c-1.4-1.1-2.6,0.5-4.1-0.7c-1.4-1.1-0.2-2.7-1.6-3.8c-1.4-1.1-2.6,0.5-4.1-0.7c-1.4-1.1-0.2-2.7-1.6-3.8"
  })))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 265.6,
    y1: 448.4,
    x2: 265.6,
    y2: 485.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    x1: 265.6,
    y1: 386.1,
    x2: 265.6,
    y2: 429.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "c_face",
    "data-svg-origin": "444.4500274658203 162.3000030517578",
    transform: "matrix(1,0,0,1,1.7247179999999966,3.4494359999999933)",
    style: {
      transformOrigin: "0px 0px 0px"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#4c00ff",
    cx: 422.4,
    cy: 197.6,
    r: 21.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#4c00ff",
    cx: 467.2,
    cy: 185.4,
    r: 21.1
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M422,176.2c-2.3,3.6-4,2.6-6.3,6.2 c-2.3,3.6-0.6,4.7-2.9,8.3c-2.3,3.6-4,2.6-6.3,6.2c-2.3,3.6-0.6,4.7-2.9,8.3c-2.3,3.6-4,2.6-6.3,6.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M428.3,185.7c-2,3-3.6,1.9-5.6,4.9 c-2,3-0.3,4.1-2.3,7.1c-2,3-3.7,1.9-5.6,4.9c-2,3-0.3,4.1-2.3,7.1c-2,3-3.7,1.9-5.6,4.9"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M485.3,162.3c-2.3,3.6-4,2.6-6.3,6.2 c-2.3,3.6-0.6,4.7-2.9,8.3c-2.3,3.6-4,2.6-6.3,6.2c-2.3,3.6-0.6,4.7-2.9,8.3c-2.3,3.6-4,2.6-6.3,6.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M491.6,171.8c-2,3-3.6,1.9-5.6,4.9 c-2,3-0.3,4.1-2.3,7.1c-2,3-3.7,1.9-5.6,4.9c-2,3-0.3,4.1-2.3,7.1c-2,3-3.7,1.9-5.6,4.9"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4F6",
    d: "M450.1,202.1c0,0-7.4-6.5-10.2,0c-2.8,6.5,9.3,5.6,9.3,5.6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M450.1,202.1c0,0-7.4-6.5-10.2,0 c-2.8,6.5,9.3,5.6,9.3,5.6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M454.4,209.8l3.6,10.8c0.8,2.5-0.5,5.3-3.1,6.1 l0,0c-2.5,0.8-5.3-0.5-6.1-3.1l-3.6-10.8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "l_face",
    "data-svg-origin": "166.204345703125 93",
    transform: "matrix(1,0,0,1,0,3.180538499999991)",
    style: {
      transformOrigin: "0px 0px 0px"
    }
  }, _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4c00ff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 135.9,
    y1: 103.7,
    x2: 194.5,
    y2: 102.8
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4c00ff",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M170,134.9l1.3,12.1c0.3,2.8-1.8,5.3-4.6,5.6h0 c-2.8,0.3-5.3-1.8-5.6-4.6l-1.3-12.1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c00ff",
    d: "M148.5,129L148.5,129c-9.6,0.4-17.7-7.1-18.1-16.7l-0.4-10.4l34.8-1.4l0.4,10.4 C165.6,120.5,158.1,128.6,148.5,129z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c00ff",
    d: "M185.6,127.5L185.6,127.5c-9.6,0.4-17.7-7.1-18.1-16.7l-0.4-10.4l34.9-0.2l0.4,9.2 C202.7,119,195.2,127.1,185.6,127.5z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M152,93c-2,3.4-3.7,2.4-5.7,5.8 c-2,3.4-0.3,4.4-2.3,7.8c-2,3.4-3.7,2.4-5.7,5.8c-2,3.4-0.3,4.4-2.3,7.8s-3.7,2.4-5.7,5.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M158.1,101.5c-1.7,2.8-3.4,1.8-5.1,4.6 c-1.7,2.8,0,3.8-1.7,6.7c-1.7,2.8-3.4,1.8-5.1,4.6c-1.7,2.8,0,3.9-1.7,6.7c-1.7,2.8-3.4,1.8-5.1,4.6"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M193.8,94.5c-2,3.4-3.7,2.4-5.7,5.8 c-2,3.4-0.3,4.4-2.3,7.8c-2,3.4-3.7,2.4-5.7,5.8c-2,3.4-0.3,4.4-2.3,7.8c-2,3.4-3.7,2.4-5.7,5.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M199.9,103c-1.7,2.8-3.4,1.8-5.1,4.6 c-1.7,2.8,0,3.8-1.7,6.7c-1.7,2.8-3.4,1.8-5.1,4.6c-1.7,2.8,0,3.9-1.7,6.7s-3.4,1.8-5.1,4.6"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "#F2F4F6",
    points: "167.5,120.6 155.1,121.2 167,130.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    points: "167.5,120.6 155.1,121.2 167,130.3  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "scarf_1_",
    "data-svg-origin": "475.2859649658203 252.66558837890625",
    transform: "matrix(0.99488,0.10097,-0.10097,0.99488,27.94279459476195,-46.70163756060799)",
    style: {
      transformOrigin: "0px 0px 0px"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 465.3,
    y: 253,
    transform: "matrix(0.9994 -3.367446e-02 3.367446e-02 0.9994 -8.9725 16.1596)",
    fill: "#5F86ED",
    width: 20,
    height: 43
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M468.1,292.6c0,0,2.5,1.9-0.7,8.2 c-3.2,6.3,1.6,7.9,1.6,7.9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M475.3,293c0,0,2.5,1.9-0.7,8.2 c-3.2,6.3,1.6,7.9,1.6,7.9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M482.6,293.3c0,0,2.5,1.9-0.7,8.2 c-3.2,6.3,1.6,7.9,1.6,7.9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shoes",
    "data-svg-origin": "531.4682006835938 469.6595764160156",
    transform: "matrix(0.98675,0.16219,-0.16219,0.98675,83.21408819133518,-79.98286798844038)",
    style: {
      transformOrigin: "0px 0px 0px"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c00ff",
    d: "M522.4,498.8c0,0-1.8-4.5,1.9-6.8c3.8-2.3,3.8-2.3,3.8-2.3l4.7-16.6l-2-1.1c0,0,1.4-2.7,5.5-2.3 c0,0,4.9,3.5,7.9,2.5c0,0,0.7-1.3,1.6,1.7c0,0-3.6,35.6-15.5,57.7l-8.7,16.2c-1,1.9-3.8,1.3-4-0.8c-0.8-8.2-1.1-22.1,3.7-30.8 c3.4-6,2.3-16.9,2.3-16.9"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M537.2,497.8c-1.6,0.7-2.4-1.1-4.1-0.4 c-1.6,0.7-0.9,2.5-2.5,3.3c-1.6,0.7-2.4-1.1-4.1-0.4c-1.6,0.7-0.9,2.5-2.5,3.3c-1.6,0.7-2.4-1.1-4.1-0.4"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M536.3,502.4c-1.6,0.7-2.4-1.1-4.1-0.4 c-1.6,0.7-0.9,2.5-2.5,3.3c-1.6,0.7-2.4-1.1-4.1-0.4c-1.6,0.7-0.9,2.5-2.5,3.3c-1.6,0.7-2.4-1.1-4.1-0.4"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5F86ED",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M535.4,507.1c-1.6,0.7-2.4-1.1-4.1-0.4 c-1.6,0.7-0.9,2.5-2.5,3.3c-1.6,0.7-2.4-1.1-4.1-0.4c-1.6,0.7-0.9,2.5-2.5,3.3c-1.6,0.7-2.4-1.1-4.1-0.4"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.0ae2227c29380847e936d8d5763a0617.svg";
export { ForwardRef as ReactComponent };